import React, { memo } from 'react'

const Instructions = () => {
  return (
    <div className=" border border-black rounded-md shadow-xl flex flex-col p-4 text-justify">
      <h1 className=" text-xl font-semibold text-[#07074D]">Instructions for using FASA Web</h1>
      As a user, you may try FASA through the provided examples, or provide audio and transcription pairs yourself. The following instructions will guide you through the process of using FASA web demo:
     
      <ul className=" px-4">

         <li style={{ listStyleType: "format" }} className=" mt-4">
          <strong>Enable pop-up</strong>
          <ul>
            <li style={{ listStyle: "circle" }}>

              Make sure you enable pop-up so that you can download the results from the website!
            </li>
          </ul>
        </li>

        <li style={{ listStyleType: "format" }} className=" mt-4">
          <strong>Selecting Input</strong>
          <hr></hr>
          <ul>
            <li style={{ listStyleType: "circle" }}>
              To select from provided examples, click on the dropdown menu on the left. Please select an audio and a transcription. You may preview the audio and transcription by clicking on the play button and the hyperlink, respectively.

            </li>
            <li style={{ listStyleType: "circle" }}>
              After finish selection, please click <strong>“Select from examples” </strong>at bottom.
            </li>
          </ul>
          <hr></hr>
          <h1 className=" text-xxl font-semibold text-center ">or</h1>
          <hr></hr>
          <ul>
            <li style={{ listStyleType: "circle" }}>
              To use your own audio and transcription, please upload them on the right. The web demo supports most of the audio formats. If your file has an extension not recognized by the software, an error might occur. In this case, please convert the audio to MP3 and WAV format. Currently, only TXT files are supported for the transcription.
            </li>

            <li style={{ listStyleType: "circle" }}>
               After finish selection, please click <strong>“Select from upload </strong>at bottom.
            </li>
          </ul>
          <hr></hr>
        </li>

        <li style={{ listStyleType: "format" }} className=" mt-4">
          <strong>Run and get results</strong>
          <ul>
            <li style={{ listStyleType: "circle" }}>
              Click <strong>“Process”</strong> and get the results. The processed dataset will also be downloaded as a ZIP file.
            </li>
          </ul>
        </li>
      </ul>
    </div>
  )
}

export default memo(Instructions);